import actions from "@/store/modules/client/actions";
import mutations from "@/store/modules/client/mutations";
import state from "@/store/modules/client/state";

export default {
    actions,
    mutations,
    state
}